import { render, staticRenderFns } from "./AddEditAcademicGroup.vue?vue&type=template&id=0933ff80"
import script from "./AddEditAcademicGroup.vue?vue&type=script&lang=js"
export * from "./AddEditAcademicGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports